import {GetTopMakesApiResponse} from '../types';

export const topMakesResponseMock: GetTopMakesApiResponse = [
  {
    code: 'MAKE_BMW',
  },
  {
    code: 'MAKE_SKODA',
  },
];
